/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
import React, { Component } from "react";
import ItemList from "./components/ItemList";
import { getFAQ } from "./actions";
import commonUtil from "../../utils/commonUtil";

class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      icon: "",
      title: "",
      questions: [],
    };
  }

  handleGetFaq = async () => {
    const page = { guest: "?isGuestView=true", home: "?isHomeView=true" };
    const response = await getFAQ(page[this.props.page || "guest"]);
    const newState = {
      icon: response.body.categories[0].icon,
      title: response.body.categories[0].category,
      questions: response.body.categories[0].questions,
    };
    this.setState(newState);
  };

  componentDidMount() {
    this.handleGetFaq();
  }

  render() {
    const brand = commonUtil.getBrand();
    const colors = {
      LP: "#E10098",
      GAP: "#122344",
      PB: "#970400",
      PBK: "#74b0e2",
      WS: "#e81818",
      WLM: "#ed2724",
      TRU: "#007bff",
    };

    const handleToggle = (element) => {
      const isOpen = element.ariaExpanded === "true";
      const content = element.nextElementSibling;
      const text = content.querySelector("p");
      const headers = document.querySelectorAll("article button");
      for (const header of headers) {
        header.classList.remove("active");
        header.nextElementSibling.style.height = "0px";
        header.ariaExpanded = header.id === element.id ? `${!isOpen}` : "false";
      }
      if (!isOpen) {
        element.classList.add("active");
        content.style.height = `${text.clientHeight}px`;
      }
    };

    return (
      <div className="containerStyleFAQ">
        <div className="headerStyleFAQ">
          <img
            src={
              commonUtil.getAssetURL() +
              "/images/faqs/mr/preguntas_frecuentes.png"
            }
            alt="iconFAQ"
            width="56"
            height="56"
          />
          <p className="fontTitleStyleFAQHeading">Preguntas frecuentes</p>
        </div>
        {this.state.questions &&
          this.state.questions.map((question, index) => (
            <ItemList
              key={index}
              id={index}
              handleToggle={handleToggle}
              faq={{
                header: question.question,
                text: question.answers[0].answer,
              }}
            />
          ))}
        <div>
          <a className="btnStyleFAQ" href="/FrequentlyAskedQuestions">
            <p className="fontTitleStyleFAQ" style={{ color: colors[brand] }}>
              Ver más preguntas frecuentes
            </p>
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 25"
                fill="none"
              >
                <path
                  d="M19 13.6582H13V19.6582H11V13.6582H5V11.6582H11V5.6582H13V11.6582H19V13.6582Z"
                  fill={colors[brand]}
                />
              </svg>
            </span>
          </a>
        </div>
      </div>
    );
  }
}

export default FAQ;
